
export const messages = {
    HeaderMainPage: "Главная страница",
    HeaderServices: "Услуги",
    HeaderPrice: "Запрос цены",
    HeaderNews: "Новости",
    HeaderAboutUs: "О нас",
    HeaderConcatUs: "Свяжитесь с нами",
    AboutUsTitleMainPage: "О нас",
    HeaderFAQ: "سوالات متداول",
    Lorem100: 'Lorem Ipsum - это фиктивный текст печати и верстки, используемый в индустрии печати. Lorem Ipsum является стандартным фиктивным текстом отрасли с 1500-х годов, когда неизвестный принтер взял караван типа и перетасовал его, чтобы сделать образец типа. Он выжил не только в пять веков, но и перешел к электронной вёрстке, оставаясь в основном неизменным. Он был популяризирован в 1960-х годах выпуском листов Letraset с отрывками Lorem Ipsum и, более недавно, программами электронной вёрстки, как Aldus PageMaker, включая версии Lorem Ipsum.',
    Lorem10:"Лорем Эпсом — это вымышленный текст, созданный с непостижимой простотой в полиграфической индустрии с использованием графических дизайнеров, принтеров и текстов, а также газет и графики.",
    MoreDetailsButton: 'Подробнее',
    ServicesTitleMainPage: "Услуги",
    RailroadTransportationCardTitle: "Железнодорожная транспортировка",
    MaritimeTransportationCardTitle: "Морская транспортировка",
    RoadTransportationCardTitle: "Дорожная транспортировка",
    ReadMore:"читать далее",
    HeaderGallery: "Gallery",
    AltenBenefitsTitleMainPage: "Преимущества Alten",
    AltenBenefitsCardTitle: "Быстрая транспортировка",
    LastNewsTitleMainPage: "Последние новости",
    TitleInformationCardNewsRoad: "Национальная сессия по стратегическим экономическим обменам вдоль Шелкового пути",
    TitleInformationCardNewsAirPlane: "Предложение по импорту воздушных судов старше 20 лет в Иран",
    TitleInformationCardNews: "{title}",
    CompanyLocation: "Голестан, Горган, улица Бахарестан",
    AlertSubFooter: "Все права принадлежат группе Alten",
    DesignBySubFooter: "Дизайн и разработка Altyngroup",

    // главная страница закончена

    AirTransportationTitleServices: "Авиатранспорт",
    ImportsAndExportsTitleServices: "Импорт и экспорт",
    ClearanceTitleServices: "Оформление товаров",
    TitleOfTheTransportsServices: "Сервис {title} от Alten",
    CapacityOfAltenTransportationServices: "Емкость сервиса {title} от Alten",
    CapacityOfAltenTransportationServicesTitle: "{title}",
    AltynRailTransportServiceCapacities:' Емкость железнодорожных транспортных услуг Altyn',
    AltenRoadTransportServiceCapacities:' Емкость дорожных транспортных услуг Altyn',
    CapacitiesofAltenAirTransportService:'Емкость авиационных транспортных услуг Altyn',
    AltenImportAndExportServiceCapacities:' Емкость услуг по импорту и экспорту Altyn',
    AltenClearanceServiceCapacities:'Емкость услуг по таможенному оформлению Altyn',
    CapacitiesofAltenSeaTransportationService:'Емкость морских транспортных услуг Altyn',
    LoremTitle:'Lorem Ipsum вымышленный текст.',


    // конец страницы услуг

    EnterInformationToInquireAboutThePrice: "Введите информацию для запроса цены",
    FirstAndLastNameInputLabel: "Имя и фамилия",
    PhoneNumberInputLabel: "Номер телефона",
    EmailInputLabel: "Эл. почта",
    CargoNameInputLabel: "Название груза",
    HsCodeInputLabel: "HsCode",
    CargoTonnageInputLabel: "Тоннаж груза",
    OriginInputLabel: "Происхождение",
    DestinationInputLabel: "Место назначения",
    MultiRouteInputLabel: "Маршрут груза многопутевой?",
    DegreeOfRiskOfTheGoodsInputLabel: "Степень опасности груза",
    PackageTypeInput: "Тип упаковки",
    IsTheShipmentDeclared: "Был ли груз объявлен?",
    Yes: "Да",
    No: "Нет",
    SendButtonTitle: "Отправить",
    AlertPricePage: "Наши эксперты свяжутся с вами после необходимых оценок.",
    TehranIranTitle: "Тегеран, Иран",
    EsfehanIranTitle: "Исфахан, Иран",
    TabrizIranTitle: "Тебриз, Иран",
    singleTrackTitle: "Однопутевой",
    TwoPaths: "Два маршрута",
    ThreePaths: "Три маршрута",
    LevelOne: "Уровень один",
    LevelTwo: "Уровень два",
    LevelThree: "Уровень три",
    Carton: "Картон",
    CardBoard: "Картон",
    Plastic: "Пластик",
    NameYup: 'Требуется полное имя.',
    PhoneYupNumber: 'Номер телефона должен быть числовым.',
    PhoneYupCh: 'Номер телефона должен состоять из ровно 11 символов.',
    PhoneYup: 'Требуется номер телефона.',
    EmailYup: 'Неверный адрес электронной почты.',
    EmailYupIN: 'Требуется адрес электронной почты.',
    ProductYup: 'Требуется название продукта.',
    CodeYup: 'Требуется код HS.',
    TonnageYup: 'Требуется тоннаж груза.',
    TonnageYupNumber: 'Тоннаж должен быть числовым.',
    OriginYup: 'Требуется место происхождения.',
    DestinationYup: 'Требуется место назначения.',
    RoadYup: 'Требуется тип маршрута.',
    GradeYup: 'Требуется уровень риска.',
    TypeYup: 'Требуется тип упаковки.',


    // конец страницы цены

    TitleNewsPage: "Новости группы Alten",

    // конец страницы новостей

    TitleAboutUsPage: "О группе транспорта Alten",
    SubcategoriesOfAltenGroup: "Подкатегории группы Alten",
    ViewServicesButton: "Просмотреть услуги",
    AltenHeritage:'Альтен Наследие',

    //! AboutUS
    aboutUsCards: {
        rajabGazaqh: {
            name: 'Раджаб Казак',
            languages: ['Персидский', 'Казахский', 'Турецкий', 'Азербайджанский', 'Туркменский'],
            extra: 'Почетный президент группы Altyn',
        },
        ehsanVakili: {
            name: 'Эхсан Вакили',
            role: 'Главный исполнительный директор',
            languages: ['Персидский', 'Туркменский'],
            location: 'Центральный офис в Горгане',
            description: [
                `История группы Altyn берет свое начало с момента, когда компания Altyn Rail Golestan начала свою деятельность на пограничной железнодорожной станции Инче-Бурун в Иране, оказывая услуги уважаемым торговцам и беря на себя полную ответственность за все транспортные и таможенные процессы. Будучи первой созданной и зарегистрированной компанией на железнодорожной станции Инче-Бурун, она стала наиболее оснащенной экспедиторской компанией и наиболее специализированной фирмой, готовой предоставить полный спектр услуг. Эти заслуги, наряду с многочисленными другими достижениями, являются важными вехами в истории группы Altyn.`,
                `Группа Altyn гордится тем, что является первой и лучшей в отрасли. Долгосрочное, непрерывное и стабильное сотрудничество с ее лояльными клиентами является свидетельством качества услуг, предоставляемых группой Altyn, и будет продолжать служить доказательством приверженности компании к совершенству.`,
            ],
        },
        naghimeChamani: {
            name: 'Нагиме Чамани',
            role: 'Генеральный директор',
            languages: ['Персидский', 'Казахский'],
            location: 'Иран - Голестан - Горган - ул. Шахид Бехешти',
            description: [
                `Полное удовлетворение потребностей клиентов всегда было главной целью группы Altyn с самого начала и до сих пор. Цель создания Altyn Miras Golestan заключалась в расширении услуг компании и охвате большего числа потребностей клиентов в регионе. Увеличение взаимодействия с государственными организациями и учреждениями, особенно с Организацией портов и морского судоходства Исламской Республики Иран, предоставление разнообразных транспортных услуг, получение необходимых разрешений на транзит и устранение других пробелов в обслуживании в регионе являются услугами, которые Altyn Miras Golestan предоставляет клиентам и другим компаниям.`,
            ],
        },
        safarAraghbai: {
            name: 'Сапар Арыкбай',
            role: 'Технический директор',
            languages: ['Русский', 'Персидский', 'Казахский', 'Туркменский'],
            location: 'Иран - Голестан - Инче-Бурун',
            description: [
                `История группы Altyn берет свое начало с момента, когда компания Altyn Rail Golestan начала свою деятельность на пограничной железнодорожной станции Инче-Бурун в Иране, оказывая услуги уважаемым торговцам и беря на себя полную ответственность за все транспортные и таможенные процессы. Будучи первой созданной и зарегистрированной компанией на железнодорожной станции Инче-Бурун, она стала наиболее оснащенной экспедиторской компанией и наиболее специализированной фирмой, готовой предоставить полный спектр услуг.`,
                `Группа Altyn гордится тем, что является первой и лучшей в отрасли. Долгосрочное, непрерывное и стабильное сотрудничество с ее лояльными клиентами является свидетельством качества услуг, предоставляемых группой Altyn.`,
            ],
        },
        boranBayeva: {
            name: 'Буранбаева Гулнара Жарылкасыновна',
            role: 'Генеральный директор',
            languages: ['Русский', 'Казахский'],
            location: 'Казахстан, Шымкент, район Абай',
            description: [
                `В мире логистики существует множество пробелов и разрывов, создающих проблемы и препятствия для частных лиц и компаний, работающих в регионе. Эта компания, обладая полным пониманием этих пробелов, стремится создать прочный и надежный мост между компаниями и активными лицами в странах региона для ускорения и улучшения транспортных процессов. Эта цепочка укрепляется и поддерживается за счет прямых и специализированных связей между различными компаниями внутри группы Altyn.`,
                `Предоставление кодов маршрутов, предоставление вагонов, организация обратных грузов для региональных вагонов, особенно из Ирана, отслеживание и трассировка грузов, выдача разрешений на проезд и многое другое являются ценными услугами, которые надежно и официально предоставляются клиентам и другим компаниям в регионе.`
            ],
        },
        berdinazarOvezov: {
            name: 'Бердиназар Овезов',
            role: 'Генеральный директор',
            languages: ['Персидский', 'Туркменский', 'Английский', 'Русский', 'Немецкий'],
            location: 'Туркменистан, Ашхабад, ул. Анталия, 182',
            description: [
                `Туркменистан благодаря своему стратегическому географическому положению, членству в странах СНГ, развитой и развивающейся железнодорожной инфраструктуре, границам с такими странами, как Казахстан и Иран, и выходу к Каспийскому морю является одним из самых перспективных и привлекательных логистических центров региона для транспортных операторов. В соответствии со стратегическими целями группы Altyn, создание Altyn Hayat в Туркменистане стало реальностью. Прямые связи с железными дорогами и государственными органами Туркменистана, предоставление вагонов, отслеживание и трассировка грузов, отправляемых через и через Туркменистан, и обработка транзитных вагонов являются услугами, которые Altyn Hayat предоставляет клиентам, используя взаимосвязанную инфраструктуру группы Altyn.`,
            ],
        },
        abdazizSakhi: {
            name: 'Абдул Азиз Саки',
            role: 'Генеральный директор',
            languages: ['Персидский', 'Дари'],
            location: 'Афганистан, Кабул, Наджаран, район 11',
            description: [
                `Учитывая стратегическую оценку и важные логистические узлы Афганистана в Акине, Торгунди, Хафе и Герате, группа Altyn сочла необходимым установить свое присутствие в этих районах. Это позволяет предоставлять экспедиторские и торговые услуги, среди прочего, для лучшей поддержки своих клиентов и деловых партнеров. Еще одним достижением группы Altyn является прямое сотрудничество с Афганской железнодорожной администрацией и государственными органами Афганистана, что позволяет надежно и напрямую обслуживать эти центры для своих деловых партнеров и уважаемых клиентов.`,
            ],
        },
        hamedAbbasi: {
            name: 'Хамед Аббаси',
            role: 'Генеральный директор',
            languages: ['Персидский', 'Английский'],
            location: 'Иран - Голестан - Горган - ул. Шахид Бехешти',
            description: [
                `Компания Altyn Digital Technology, родившаяся из мира логистики, использует информатику и программирование для решения проблем профессионалов и практиков транспортной отрасли. Видение компании заключается в создании интегрированной транспортной системы в регионе, начиная с услуг, предоставляемых компаниям группы Altyn. Объединяя технологии и логистику, компания постепенно приближается к своей цели. Например, предоставление услуг по автоматизации транспортной системы, отслеживанию и мониторингу вагонов и контейнеров в пути, а также предоставление другой современной инфраструктуры торговцам, владельцам вагонов, экспедиторам и многим другим являются ценными услугами, предлагаемыми этой компанией.`,
            ],
        },
        asefNazerian: {
            name: 'Асеф Назериан',
            role: 'Главный исполнительный директор',
            languages: ['Персидский', 'Английский', 'Туркменский'],
            location: 'Иран - Голестан - Горган - ул. Шахид Бехешти',
            description: [
                `Компания Altyn Sareban, как часть группы Altyn, специализируется на предоставлении комплексных логистических решений. С акцентом на удовлетворенность клиентов и операционное превосходство, компания предлагает широкий спектр услуг, включая управление транспортировкой, таможенное оформление и оптимизацию цепочки поставок.`,
                `Используя обширную сеть и опыт группы Altyn, Altyn Sareban обеспечивает эффективные и надежные транспортные услуги по всему региону, соединяя предприятия и способствуя торговле между Центральной Азией, Ираном и другими странами.`,
            ],
        },
    },

    //? CompanyInfoCard
    languages: 'языки',
    contactInfo: 'контактная информация',
    description: 'описание',


    // конец страницы "О нас"
    ContactUs:"Свяжитесь с нами",
    PhoneNumbers: "Телефоны:",
    WhatsAppAndTelegram: "WhatsApp и Telegram:",
    SocialMedia: "Социальные сети:",
    mapLocation: "Местоположение штаб-квартиры Alten на карте / Нажмите здесь",


    //end Contact us

    HomeAndNews:"Дом/Новости/",
    Pm:"п.п." ,
    Am:"д.п."

}
